import { EQUIPMENT_TYPES_PER_STOCK_LOCATION_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/equipment_types_per_stock_location_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['equipmentTypesPerStockLocationIndex']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
